module.exports = __webpack_public_path__ + "images/backgrounds/mountain/medium.07627e0760eb74e7109a.jpg";


//////////////////
// WEBPACK FOOTER
// ./resources/images/backgrounds/mountain/medium.jpg
// module id = FFk4
// module chunks = 13